module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal-popup-black', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowModalAfterCRMResponse),
      expression: "isShowModalAfterCRMResponse"
    }],
    attrs: {
      "title": "Відповідь CRM системи",
      "textBtnPrimary": "Ok",
      "isShowBtnSecondary": false,
      "textBtnSecondary": ''
    },
    on: {
      "eventBybtnPrimary": _vm.modalOk,
      "eventBybtnSecondary": _vm.modalClose,
      "eventBybtnCrissCross": _vm.modalCrissCross
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function() {
        return [_c('div', {
          staticClass: "content"
        }, [_vm._v("\n      " + _vm._s(_vm.$t("profile.modal_crm_response.text")) + "\n    ")])]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42190bca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile-page/impl/delete-account/imlp/modal-crm-response/index.vue
// module id = 410
// module chunks = 1